import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Bank } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class BankModule extends VuexModule {
    @Action
    [Bank.showBank]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/bank/show`,{})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}